
// 协议
import Contact from '@/views/contract/index'
import ContractServer from '@/views/contract/server'
import ContractPrivacy from '@/views/contract/privacy'


export default [

    {path: '/contract',component:Contact, name: 'contract',children: [
        {path: 'server',component:ContractServer,name: 'server', meta: {login:1},},
        {path: 'privacy',component:ContractPrivacy,name: 'privacy', meta: {login:1},},
    ],redirect: '/contract/server'},

]




// WEBPACK FOOTER //
// ./src/router/contract.js